import { Link } from "react-router-dom";

export default function Logo({ size = "md", to = "/", showText = true }) {
  const dims = {
    sm: { h: "h-8", text: "text-base" },
    md: { h: "h-10", text: "text-xl" },
    lg: { h: "h-14", text: "text-3xl" },
  }[size];

  return (
    <Link
      to={to}
      data-testid="locateos-logo"
      className="inline-flex items-center gap-2.5 group"
    >
      <img
        src="/locateos-icon.png"
        alt="LocateOS"
        className={`${dims.h} w-auto object-contain drop-shadow-[0_0_12px_rgba(249,115,22,0.5)] transition-transform group-hover:scale-105`}
      />
      {showText && (
        <span className={`${dims.text} font-display font-extrabold tracking-tight leading-none`}>
          <span className="text-white">Locate</span>
          <span className="text-[#F97316]">OS</span>
        </span>
      )}
    </Link>
  );
}
